import React from "react";

const MAP = {
  on_track: { cls: "badge-track", label: "On track", prio: "normal" },
  attention: { cls: "badge-attn", label: "Needs attention", prio: "high" },
  waiting_customer: { cls: "badge-wait", label: "Waiting on customer", prio: "normal" },
  pending: { cls: "badge-neutral", label: "Pending", prio: "normal" },
  approved: { cls: "badge-approved", label: "Approved", prio: "low" },
  rejected: { cls: "badge-rejected", label: "Rejected", prio: "high" },
  draft: { cls: "badge-neutral", label: "Draft", prio: "normal" },
  draft_from_contractor: { cls: "badge-attn", label: "Contractor draft", prio: "normal" },
  revision_requested: { cls: "badge-attn", label: "Revision requested", prio: "high" },
  waiting_on_designer: { cls: "badge-attn", label: "Waiting on designer", prio: "high" },
  waiting_on_contractor: { cls: "badge-attn", label: "Waiting on contractor", prio: "high" },
  waiting_on_customer: { cls: "badge-wait", label: "Waiting on customer", prio: "normal" },
  done: { cls: "badge-track", label: "Done", prio: "low" },
  awaiting_pm_approval: { cls: "badge-attn", label: "PM approval", prio: "normal" },
  published: { cls: "badge-approved", label: "Published", prio: "low" },
  new_project: { cls: "badge-new", label: "New project", prio: "normal" },
  stale: { cls: "badge-attn", label: "Stale — 5+ days", prio: "high" },
  on_hold: { cls: "badge-critical", label: "On hold", prio: "critical" },
  dispute: { cls: "badge-critical", label: "Dispute", prio: "critical" },
  overdue: { cls: "badge-critical", label: "Overdue", prio: "critical" },
  completed: { cls: "badge-low", label: "Completed", prio: "low" },
  in_progress: { cls: "badge-track", label: "In progress", prio: "normal" },
};

export default function StatusBadge({ status, label }) {
  const m = MAP[status] || { cls: "badge-neutral", label: label || status, prio: "normal" };
  return (
    <span className={`badge ${m.cls}`} data-testid={`status-${status}`} data-priority={m.prio}>
      {m.prio === "critical" && <span className="critical-dot" aria-hidden />}
      {label || m.label}
    </span>
  );
}
